import React, { Component } from 'react'
import { Router, Switch, Redirect } from 'react-router-dom'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Header, Icon, Loader } from 'semantic-ui-react'
import { SemanticToastContainer } from 'components/react-semantic-toasts'
import Loadable from 'react-loadable'
import * as Sentry from '@sentry/browser'
import detectBrowserLanguage from 'detect-browser-language'

import { fetchUser } from '_actions/auth'
import { fetchUserLoggedTreeNodes } from '_actions/treeNodes'
import { fetchTranslations } from '_actions/i18n'
import { fetchEducationLevels } from '_actions/education_levels'
import { mydOauthURL, mydOauthToken } from 'config'
import { toast } from 'components/react-semantic-toasts'
import MydCreateStoryModal from 'components/myd-create-story-modal'
import Nav from 'components/Nav'
import ModalPrivacy from 'react-components/myd-widgets/Widgets/ModalPrivacy'
import MydRoute from 'components/MydRoute'
import { changeLanguage } from '_actions/i18n'
import { newSupportTech } from '_actions/support'
import {
  SENTRY_DSN,
  SENTRY_ENV,
} from 'config'
import history from 'utils/history'

import 'react-datepicker/dist/react-datepicker.css'
import 'draft.css'

if (SENTRY_ENV) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
  })
}


export const Loading = () => <Loader active>Loading...</Loader>


const GlobalEvaluations = Loadable({
  loader: () => import('scenes/Widgets/Evaluation'),
  loading: Loading,
})
const Eportfolio = Loadable({
  loader: () => import('scenes/Eportfolio'),
  loading: Loading,
})
const SceneNotifications = Loadable({
  loader: () => import('scenes/Notifications'),
  loading: Loading,
})
const EportfolioEdit = Loadable({
  loader: () => import('scenes/Eportfolio/EportfolioEdit'),
  loading: Loading,
})
const NodePreview = Loadable({
  loader: () => import('scenes/NodePreview'),
  loading: Loading,
})
const MydActivityCrud = Loadable({
  loader: () => import('scenes/MydActivityCrud'),
  loading: Loading,
})
const MydActivityList = Loadable({
  loader: () => import('scenes/MydActivityCrud/list'),
  loading: Loading,
})
const MydActivityPreview = Loadable({
  loader: () => import('scenes/MydActivityCrud/preview'),
  loading: Loading,
})
const MydActivityToDo = Loadable({
  loader: () => import('scenes/MydActivityCrud/to_do'),
  loading: Loading,
})
const MydCompetenceCrud = Loadable({
  loader: () => import('scenes/MydCompetenceCrud'),
  loading: Loading,
})
const MydPlanning = Loadable({
  loader: () => import('scenes/MydPlanning'),
  loading: Loading,
})
const SupportService = Loadable({
  loader: () => import('scenes/SupportService'),
  loading: Loading,
})
const EvaluationResults = Loadable({
  loader: () => import('scenes/EvaluationResults'),
  loading: Loading,
})
const MyStudentGallery = Loadable({
  loader: () => import('scenes/MyStudentGallery'),
  loading: Loading,
})
const MyCenterEportfolio = Loadable({
  loader: () => import('scenes/MyCenterEportfolio'),
  loading: Loading,
})
const Planning = Loadable({
  loader: () => import('scenes/Planning'),
  loading: Loading,
})
const TasksToDo = Loadable({
  loader: () => import('scenes/TasksToDo'),
  loading: Loading,
})
const TeacherTasks = Loadable({
  loader: () => import('scenes/TeacherTasks'),
  loading: Loading,
})


export const NotFound = (props) => (
  <Header id='main-container' as='h2' icon textAlign='center'>
    <Icon color='red' name='exclamation triangle' />
    <Header.Content>
      { props.title || '404 Not Found' }
      <Header.Subheader>
        { props.message || '' }
        { props.children || null }
      </Header.Subheader>
    </Header.Content>
  </Header>
)


class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      isLoading: true,
    }
    this.changeLanguage = this.changeLanguage.bind(this)
  }

  componentDidMount() {
    const token = mydOauthToken()
    if ( token ) {
      this.props.fetchUser().then((user) => {

        this.changeLanguage(user.locale)
        this.props.fetchUserLoggedTreeNodes().catch(err => {
          toast({
            type: 'error',
            title: 'Ops...',
            description: 'Error loading classgroups. Please refresh the page.',
          })
        })
        this.setState({
          isLoading: false,
        })

      }).catch(err => {
        window.location = mydOauthURL()

      })

      this.props.fetchEducationLevels()

    } else {

      const language = detectBrowserLanguage().split("-").reverse().pop()
      this.changeLanguage(language)
      this.setState({
        isLoading: false,
      })

    }
  }

  changeLanguage(lang) {
    this.props.fetchTranslations(lang)
    this.props._changeLanguage(lang)
  }

  componentDidCatch(error, info) {
    const { auth } = this.props

    Sentry.withScope(scope => {
      Object.keys(info).forEach(key => {
        scope.setExtra(key, info[key])
      })
      if (auth.user) {
        scope.setUser({
          'email': auth.user.email,
          'username': auth.user.username,
          'url': window.location.pathname + window.location.search,
          'id': auth.user.id,
        })
      }
      Sentry.captureException(error)
    })
    newSupportTech({
      subject: error.name,
      body: `URL: ${window.location}\r\r\r${error.message}\r\r\r${info.componentStack}`,
    })
    this.setState({
      redirect: '/error404'
    })
  }

  render() {
    let { auth } = this.props

    if (this.state.isLoading) {
      return (
        <Loader active>
          Loading user data...
        </Loader>
      )
    }

    if (auth.treeNodes.isFetching === true) {
      return (
        <Loader active>
          Loading user classgroups...
        </Loader>
      )
    }

    let redirectOnError = null
    if (this.state.redirect !== false) {
      redirectOnError = <Redirect to={ this.state.redirect } />
      this.setState({
        redirect: false,
      })
    }

    return (
      <Router history={ history }>
        <>
          <MydCreateStoryModal />
          <SemanticToastContainer position='bottom-center' />
          <Nav changeLanguage={ this.changeLanguage } />
          <ModalPrivacy />
          <Switch>

            { /*Eportfolio pages*/ }
            <Redirect from='/' exact to='/eportfolio/mine' />
            { redirectOnError }
            <MydRoute exact path='/support-service' component={ SupportService } />
            <MydRoute exact path='/assestment-results' component={ EvaluationResults } />
            <MydRoute exact path='/my-students-gallery' component={ MyStudentGallery } />
            <MydRoute
              exact
              path='/gallery'
              render={
                props => <MyStudentGallery {...props} isPublic={ true } />
              }
              isPublic={ true }
            />
            <MydRoute exact path='/my-center-eportfolio' component={ MyCenterEportfolio } />
            <MydRoute exact path='/eportfolio/mine' render={ () => <Redirect to={ `/eportfolio/${auth.user.url}` } /> } />
            <MydRoute exact path='/eportfolio/setup' render={ props => <EportfolioEdit {...props} isEditing={true} /> } />
            <MydRoute exact path='/eportfolio/:userUrl' component={ Eportfolio } isPublic={ true }/>
            <MydRoute exact path='/notifications' component={ SceneNotifications } />

            <MydRoute path='/myd/activities' exact component={ MydActivityList } />
            <MydRoute path='/myd/activities/new' exact component={ MydActivityCrud } />
            <MydRoute path='/myd/activities/:mydActivityId(\d+)/edit' exact component={ MydActivityCrud } />
            <MydRoute path='/myd/activities/:mydActivityId(\d+)' exact component={ MydActivityPreview } />
            <MydRoute path='/myd/activities/todo' exact component={ MydActivityToDo } />
            <MydRoute path='/myd/competences' exact component={ MydCompetenceCrud } />
            <MydRoute path='/myd/planning/:planningId(\d+)?' component={ MydPlanning } />

            { /* Criss System */ }
            { /*Scenarios / Activities / Tasks (nodes) pages*/ }
            <MydRoute path='/node/:nodeId(\d+)/:childId(\d+)?' exact render={
              props => {
                if (_.isUndefined(props.match.params.childId))
                  return <Redirect to={ `/node/${props.match.params.nodeId}/${props.match.params.nodeId}` } />
                return <NodePreview { ...props } />
              }
            }
            />

            { /*Planning Tool pages*/ }
            { /*<Route path='/planning' render={ () => <Grid container><Grid.Column><Segment><h1>We are updating the planning tool.</h1></Segment></Grid.Column></Grid> } />*/ }
            <MydRoute path='/planning/:planningId(\d+)?' component={ Planning } />

            { /*TasksToDo*/ }
            <MydRoute path='/tasks-to-do/:plId(\d+)?' exact component={ TasksToDo } />
            <MydRoute path='/tasks' exact component={ TeacherTasks } />

            { /*Evaluation widget pages*/ }
            <MydRoute path='/widgets/:widgetId(\d+)/evaluation' component={ GlobalEvaluations } />

            <MydRoute component={ NotFound } isPublic={ true } />
          </Switch>
        </>
      </Router>
    )
  }
}

export default connect(
  store => ({
    auth: store.auth,
    i18n: store.i18n,
  }),
  dispatch => ({
    fetchUser: bindActionCreators(fetchUser, dispatch),
    fetchUserLoggedTreeNodes: bindActionCreators(fetchUserLoggedTreeNodes, dispatch),
    fetchTranslations: bindActionCreators(fetchTranslations, dispatch),
    fetchEducationLevels: bindActionCreators(fetchEducationLevels, dispatch),
    _changeLanguage: bindActionCreators(changeLanguage, dispatch),
  }),
)(App)
